require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projects-stronglist-privacy.json") })
        }
      }, "path---projects-stronglist-privacy");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projects-stronglist-privacy!./.cache/json/projects-stronglist-privacy.json
// module id = 287
// module chunks = 231608221292675